// frontend/packs/application.js

/* eslint-disable import/first, import/newline-after-import */

import 'init/polyfills';

import 'styleguide';
import 'init';

import 'layouts/page/page';
import 'components/global/site-header/site-header';
import 'components/global/site-footer/site-footer';

import 'components/sessions/login-form/login-form';
import 'components/sessions/registration-form/registration-form';
import 'components/sessions/reset-password-form/reset-password-form';
import 'components/sessions/update-password-form/update-password-form';

import 'components/sessions/signup-survey/signup-survey';

import 'components/util/ad-container/ad-container';
import 'components/util/logos/logos';

import 'components/util/resource-action-buttons/resource-action-buttons';

import 'components/resources/show/modal-view/modal-view'; // split-test: resource_show_modal_view

/* shared */
import 'components/resources/grid/grid';
import 'components/resources/vertical-grid/vertical-grid'; // split-test vertical_grid_infinite_scroll_v2
import 'components/util/pricing-block/pricing-block';
import 'components/pricing/faq/faq';
import 'components/util/tags-carousel/tags-carousel';
import 'components/global/promos/promo-popup';
import 'components/util/block-pager/block-pager';
import 'components/util/ez-drop-down/ez-drop-down';
import 'components/global/photos-banner/photos-banner';

import 'components/global/support/rate-limit/rate-limit';

import { featureEnabled, splitTestEnabled } from 'lib/helpers'; // eslint-disable-line import/order

import { Application } from 'stimulus';
export const application = Application.start(); // eslint-disable-line import/prefer-default-export

import AdsController from 'controllers/ads-controller';
application.register('ads-main', AdsController);

import GoogleAnalyticsController from 'components/analytics/google/google-analytics-controller';
application.register('google-analytics', GoogleAnalyticsController);

import KlaviyoAnalyticsController from 'components/analytics/klaviyo/klaviyo-analytics-controller';
application.register('klaviyo-analytics', KlaviyoAnalyticsController);

import ClickTrackController from 'controllers/click-track-controller';
application.register('click-track', ClickTrackController);

import RelatedResourceController from 'controllers/related-resource-controller';
application.register('related-resource', RelatedResourceController);

import SiteHeaderController from 'components/global/site-header/site-header-controller';
application.register('site-header', SiteHeaderController);

// feature: photos-banner
import PhotosBannerController from 'components/global/photos-banner/photos-banner-controller';
if (featureEnabled('photos-banner')) {
  application.register('photos-banner', PhotosBannerController);
}

import 'components/collections/collection-util-modal';
import 'components/collections/collections-modal/collections-modal';
import 'components/collections/collections-search-form/collections-search-form';
import 'components/collections/collections-privacy-control/collections-privacy-control';
import 'components/collections/collections-alert/collections-alert';

import LanguageSwitcherController from 'components/util/language-switcher/language-switcher-controller';
application.register('language-switcher', LanguageSwitcherController);

import FlashMessageController from 'components/util/alerts/flash/flash-message-controller';
application.register('flash-message', FlashMessageController);

import EzModalController from 'layouts/modal/modal-controller';
application.register('ez-modal', EzModalController);

import LoginFormController from 'components/sessions/login-form/login-form-controller';
application.register('login-form', LoginFormController);

import SearchAnalyticsController from 'components/analytics/search/search-analytics-controller';
application.register('search-analytics', SearchAnalyticsController);

import SearchController from 'controllers/search-controller';
application.register('ez-search', SearchController);

import SearchFormController from 'components/search/search-form/search-form-controller';
// feature: photos
import SearchFormControllerLegacy from 'components/search/search-form/search-form-controller--legacy';
if (featureEnabled('photos')) {
  application.register('search-form', SearchFormController);
} else {
  application.register('search-form', SearchFormControllerLegacy);
}

import PartnerPopupController from 'components/partner/partner-popup-controller';
application.register('partner-popup', PartnerPopupController);

import RegistrationsAccountFormController from 'components/sessions/registration-form/account-form-controller';
application.register('registrations-account-form', RegistrationsAccountFormController);

import RegistrationsDetailsFormController from 'components/sessions/registration-form/details-form-controller';
application.register('registrations-details-form', RegistrationsDetailsFormController);

import ResetPasswordFormController from 'components/sessions/reset-password-form/reset-password-form-controller';
application.register('reset-password-form', ResetPasswordFormController);

import RecaptchaController from 'components/util/recaptcha/recaptcha-controller';
application.register('recaptcha', RecaptchaController);

import SocialSessionButtonsController from 'components/sessions/social-session-buttons/social-session-buttons-controller';
application.register('social-session-buttons', SocialSessionButtonsController);

import ResourcesGridController from 'components/resources/grid/grid-controller';
application.register('resources-grid', ResourcesGridController);

import SignupModalController from 'components/sessions/signup-modal-controller';
application.register('signup-modal', SignupModalController);

import SignupSurveyModalController from 'components/sessions/signup-survey/signup-survey-modal-controller';
application.register('signup-survey-modal', SignupSurveyModalController);

import SignupSurveyFormController from 'components/sessions/signup-survey/signup-survey-form-controller';
application.register('signup-survey-form', SignupSurveyFormController);

import EzDropDownController from 'components/util/ez-drop-down/ez-drop-down-controller';
application.register('ez-drop-down', EzDropDownController);

import CollectionsModalController from 'components/collections/collections-modal/collections-modal-controller';
application.register('collections-modal', CollectionsModalController);

import CollectionsModalFormController from 'components/collections/collections-modal/collections-modal-form-controller';
application.register('collections-modal-form', CollectionsModalFormController);

import CollectionsSearchFormController from 'components/collections/collections-search-form/collections-search-form-controller';
application.register('collections-search-form', CollectionsSearchFormController);

import CollectionsPrivacyControlController from 'components/collections/collections-privacy-control/collections-privacy-control-controller';
application.register('collections-privacy-control', CollectionsPrivacyControlController);

import CollectionsAlertController from 'components/collections/collections-alert/collections-alert-controller';
application.register('collections-alert', CollectionsAlertController);

import BrowsePhotosController from 'components/browse/browse-photos/browse-photos-controller';
application.register('browse-photos', BrowsePhotosController);

import BrowseVectorsController from 'components/browse/browse-vectors/browse-vectors-controller';
application.register('browse-vectors', BrowseVectorsController);

/* start: split-test vertical_grid_infinite_scroll_v2 */

import ResourcesVerticalGridController from '../components/resources/vertical-grid/vertical-grid-controller';
import InfiniteScrollController from '../components/search/search-results/infinite-scroll-controller';

if (splitTestEnabled('vertical-grid-infinite-scroll')) {
  application.register('vertical-grid', ResourcesVerticalGridController);
  application.register('infinite-scroll', InfiniteScrollController);
}

/* end: split-test vertical_grid_infinite_scroll_v2 */
